<!-- 新版本添加账号 -->
<template>
    <el-dialog
        title="提示"
        :visible.sync="show"
        width="760px"
        custom-class="addaccount_dialog"
        @close="handleClose">
        <span slot="title" class="addAccount_tit" :class="[titleObj[step].class]">
            {{ titleObj[step].text }}
        </span>
        <div v-if="step==1" class="content-box">
            <div class="form-title">用户身份信息</div>
            <el-form :model="ruleForm" :rules="rules" ref="formRef1" label-width="140px" class="demo-ruleForm">
                <el-form-item label="真实姓名" prop="name">
                    <div class="addaccount_item_con">
                        <el-input v-model="ruleForm.name"></el-input>
                    </div>
                </el-form-item>
                 <el-form-item label="身份证号" prop="idcard">
                    <div class="addaccount_item_con">
                        <el-input v-model="ruleForm.idcard"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="身份证图片" class="is-required">
                    <div class="addaccount_item_con">
                        <uploadImg :data="uploadDeployList" :ruleForm="ruleForm" :uploadObj="uploadObj" @change="editAvatarUrl" :isSubmitFlag="isSubmitFlag" @deleteItem="deleteItem" :is_material="false"></uploadImg>
                    </div>
                </el-form-item>
            </el-form>
            <div class="form-title">账户信息</div>
            <el-form :model="ruleForm" :rules="rules" ref="formRef2" label-width="140px" class="demo-ruleForm">
                <el-form-item label="办卡银行" prop="bank_id">
                    <div class="addaccount_item_con">
                        <el-select v-model="ruleForm.bank_id" placeholder="请选择办卡银行">
                            <el-option
                            v-for="item in candidates"
                            :key="item.label"
                            :label="item.bank_name"
                            :value="item.bank_id">
                            </el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="银行卡号" prop="account">
                    <div class="addaccount_item_con">
                        <el-input v-model="ruleForm.account"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="预留手机号" prop="account_phone">
                    <div class="addaccount_item_con">
                        <el-input v-model="ruleForm.account_phone"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="用户协议" >
                    <div class="addaccount_item_con">
                         <el-checkbox v-model="agreementStatus"><span @click.stop.prevent="userAgreement()">查看用户协议</span></el-checkbox>
                    </div>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="submit(1)" class="submit-btn">下一步</el-button>
        </div>
        <div v-if="step==2" class="see-sure-box">
            <div class="item-box">
                <div class="title">用户信息</div>
                <div class="item-son">
                    <div class="item-son-title">姓名：</div>
                    <div class="item-son-content">{{ this.ruleForm.name }}</div>
                </div>
                <div class="item-son">
                    <div class="item-son-title">身份证：</div>
                    <div class="item-son-content">{{ this.ruleForm.idcard }}</div>
                </div>
            </div>
            <div class="item-box">
                <div class="title">账户信息</div>
                <div class="item-son">
                    <div class="item-son-title">办卡银行：</div>
                    <div class="item-son-content">{{ currentBankName }}</div>
                </div>
                <div class="item-son">
                    <div class="item-son-title">银行卡号：</div>
                    <div class="item-son-content">{{ this.ruleForm.account }}</div>
                </div>
                <div class="item-son">
                    <div class="item-son-title">预留手机号：</div>
                    <div class="item-son-content">{{ this.ruleForm.account_phone }}</div>
                </div>
            </div>
            <div class="btns-box">
                <el-button @click="step=1" class="btn">上一步</el-button>
                <el-button type="primary" @click="submit(2)" class="btn">确认提交</el-button>
            </div>
        </div>
         <upload-file ref="uploadFile" uploadType="img" :accept="['.jpg','.png','.jpeg']" :multiple="false" uploadSize="5mb" :isAddSucaiFlag="false" :accumulate="true" @beforeUpload="beforeUpload" @change="uploadProgress" @uploadSucess="uploadSucess"></upload-file>
    </el-dialog>

</template>
<script>
import { mapActions } from 'vuex'
import { throttle } from 'lodash-unified'
import uploadFile from '@/components/newUpload/upload.vue'
import uploadImg from '@/pages/qualifications/uploadImg.vue'
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        value(nval){
            if(nval) this.step=1
            this.show = nval
        }
    },
    components: {
        'upload-file': uploadFile,
        uploadImg
    },
    data() {
        const validateRules = (rule, value, callback, typeObj) => {
            if(value == '') {
                callback(new Error(typeObj.msg))
            } else {
                if(this.rulesObj[rule.field]) {
                    let list = this.rulesObj[rule.field].filter(item => !item.rules.test(value))
                    if(list.length == this.rulesObj[rule.field].length) {
                        callback(new Error(list[0].msg))
                    }
                }
                if(rule.field == 'idcard') {
                    if(!this.isPuber()) {
                        callback(new Error('身份证不符合18至60岁'))
                    }
                }
                callback()
            }
        }
        return {
            show: false, // 显示此弹窗
            ruleForm: {
                name: '',
                idcard: '',
                account: '',
                account_phone: '',
                bank_id: '',
                identity_card_img_front: '',
                identity_card_img_reverse: '',
                account_type: 2, // 1支付宝 2银行
                channel_type: 2 //渠道商:1=抖推猫支付,2=富友支付
            },
            step: 2,
            titleObj: {
                '1': {text: '为了您的资金安全，大额提现会通过第三方支付代发。请填写实名信息和银行卡进行验证。', class: ''},
                '2': {text: '信息提交后无法更改请再次确认', class: 'tit2'}
            },
            candidates: [],
            rulesObj: {
                name: [
                    {
                        rules: /^[\u4e00-\u9fa5]{1,15}(·[\u4e00-\u9fa5]{1,15}){0,2}$/,
                        msg: '真实姓名格式不正确'
                    }
                ],
                idcard: [
                    {
                        rules: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                        msg: '身份证号码有误，请修改'
                    }
                ],
                account_phone: [
                    {
                        rules: /^1[123456789]\d{9}$/,
                        msg: '手机有误，请修改'
                    }
                ],
                account: [
                    {
                        rules: /^\d{14,22}$/,
                        msg: '银行卡号有误，请修改'
                    }
                ]
            },
            rules: {
                name: [
                    { required: true, validator: (rule, value, callback) => { validateRules(rule, value, callback,{ msg: '请输入真实姓名' }) },trigger: 'blur' }
                ],
                idcard: [
                    { required: true, validator: (rule, value, callback) => { validateRules(rule, value, callback,{ msg: '请输入身份证号' }) }, trigger: 'blur' }
                ],
                bank_id: {required: true, message: '请选择办卡银行', trigger: 'change'},
                account: {
                    required: true, validator: (rule, value, callback) => { validateRules(rule, value, callback,{ msg: '请输入银行卡账户', type: 'account' }) }, trigger: 'blur'
                },
                account_phone: {
                    required: true, validator: (rule, value, callback) => { validateRules(rule, value, callback,{ msg: '请输入预留手机号' }) }, trigger: 'blur'
                }
            },
            uploadDeployList: [
                {
                    prop: 'identity_card_img_front',
                    tit: '身份证正面',
                    width: 170,
                    height: 108,
                    titFlag: true,
                    required: true
                },
                {
                    prop: 'identity_card_img_reverse',
                    tit: '身份证反面',
                    width: 170,
                    height: 108,
                    titFlag: true,
                    required: true
                }
            ],
            uploadObj: {},
            isSubmitFlag: false,
			agreementStatus: false
        }
    },
    created() {
        this.bankOptionFun()
    },
    computed: {
        // 当前选择银行名称
        currentBankName(){
            if(this.ruleForm.bank_id && this.candidates.length){
                return this.candidates.find(item=>item.bank_id==this.ruleForm.bank_id).bank_name
            }else{
                return ''
            }
        }
    },
    methods: {
        ...mapActions('withdrawal', ['bindAccount', 'bankOption']),
        handleClose() {
            this.$emit('input', false)
        },
        isPuber() {
            const date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            let s_month = month.toString().padStart(2, 0)
            let s_day = day.toString().padStart(2, 0)
            // console.log(year, s_month, s_day)
            //获取18年前时间戳
            let s_year = year - 18
            let splitDate = s_year + '/' + s_month + '/' + s_day
            let date2 = new Date(splitDate)
            // let stamp = date.getTime()
            let stamp = date2.getTime()
            //获取用户生日时间戳
            let idCardNum = this.ruleForm.idcard
            //130429199003208013
            let year18 = idCardNum.substring(6, 10)
            let month18 = idCardNum.substring(10, 12)
            let day18 = idCardNum.substring(12, 14)
            let userDate = year18 + '/' + month18 + '/' + day18
            let date3 = new Date(userDate)
            let stamp1 = date3.getTime()
            //获取60年前时间戳
            // console.log(stamp,stamp1)
            let s_year60 = year - 60
            let splitDate2 = s_year60 + '/' + s_month + '/' + s_day
            let date4 = new Date(splitDate2)
            let stamp3 = date4.getTime()
            // console.log(stamp1 < stamp, '大于18岁')
            // console.log(stamp1 > stamp3, '小于60岁')
            //stamp1 是用户生日时间戳，应该小于18岁的，大于60岁的
            if (stamp1 < stamp && stamp1 > stamp3) {
                return true
            } else {
                return false
            }

        },
        // 点击底部按钮 下一步/提交
        submit: throttle(async function(type) {
            if(type==1){ // 下一步
                let resArr = []
                resArr.push(await this.validateForm(1))
                resArr.push(await this.validateForm(2))
                if(resArr.includes(false)) return
                if(!this.agreementStatus) {
                    this.$message({
                        type: 'error',
                        message: '请阅读并同意用户协议！',
                        duration: 3000
                    })
                    return false
                }
                this.step = 2
            }
            if(type==2){ // 提交
                let params = JSON.parse(JSON.stringify(this.ruleForm))
                await this.bindAccount(params)
                this.$message({
                    type: 'success',
                    message: '提交成功',
                    duration: 3000
                })
                this.$emit('submitSucess')
                this.$emit('input', false)
            }
        },1000),
        // 单个校验  返回true校验通过
        singleValidate(formRefName, itemName){
            return new Promise((resolve)=>{
                this.$refs[formRefName].validateField(itemName,(errMsg)=>{
                    if(errMsg){
                        resolve(false)
                    }else{
                        resolve(true)
                    }
                })
            })
        },
        // idCards身份证图片校验 返回true校验通过
        idCardsValidate(){
            const requiredParams = ['identity_card_img_front', 'identity_card_img_reverse']
            let flag = requiredParams.every(item => this.ruleForm[item])
            this.isSubmitFlag = true
            return flag
        },
        // 表单校验
        validateForm(type){
            return new Promise((resolve,reject)=>{
                if(type==1){ // 用户身份信息表单
                    this.$refs.formRef1.validate((valid)=>{
                        if(this.idCardsValidate() && valid) {
                            resolve(true)
                        }else{
                            resolve(false)
                        }
                    })
                }
                if(type==2){ // 账户信息表单
                    this.$refs.formRef2.validate((valid)=>{
                        if(valid) {
                            resolve(true)
                        }else{
                            resolve(false)
                        }
                    })
                }
            })
           
        },
        async bankOptionFun() {
            let res = await this.bankOption()
            this.candidates = res.bank
        },
        editAvatarUrl(name) {
            this.uploadKey = name
            this.$refs.uploadFile.uploadFile()
        },
        deleteItem(name) {
           delete this.ruleForm[name]
           this.ruleForm = {...this.ruleForm}
        },
        beforeUpload(list) {
            this.ruleForm[this.uploadKey]=''
            this.$set(this.uploadObj, this.uploadKey, {
                'process': 0,
                id: list[0].newFileName
            })
        },
        uploadProgress(list) {
            list.forEach(item => {
                for (const key in this.uploadObj) {
                    if(item.newFileName === this.uploadObj[key].id) {
                        this.$set(this.uploadObj[key], 'process', item.process)
                    }
                }
            })
        },
        uploadSucess(list, item) {
            for (const key in this.uploadObj) {
                if(item.newFileName === this.uploadObj[key].id) {
                    this.$set(this.uploadObj[key], 'process', 100)
                    this.ruleForm[key] = item.url
                    delete this.uploadObj[key]
                }
            }
        },
		checkAgreementStatus(data){
			console.log(data,this.agreementStatus);
		},
		userAgreement(data){
			// 跳转路由
			window.open(`/agreementList`)
		},
    }
}
</script>
<style lang="less">
    .addaccount_dialog {
        .el-dialog__header {
            display: flex;
            justify-content: center;
            border-bottom: 1px solid #EEEEEE;
        }
        .addaccount_item_con {
            width: 400px;
        }
        .demo-ruleForm {
            // display: flex;
            // flex-direction: column;
            // align-items: center;
        }
        .el-dialog__footer {
            display: flex;
            justify-content: center;
            border-top: 1px solid #EEEEEE;
        }
    }
</style>
<style lang="less" scoped>
    .addAccount_tit {
        display: inline-block;
        font-size: 12px;
        line-height: 20px;
        width: 553px;
        color: #EC4561;
        &.tit2{
            color: #1e9fd2;
            font-size: 18px;
            text-align: center;
        }
    }
    .content-box{
        .form-title{
            font-weight: 600;
            font-size: 15px;
            margin: 0 0 10px;
        }
        .blue-pointer{
            color: #1989fa;
            font-size: 14px;
            cursor: pointer;
        }
        .waiting-validate-status{
            color: red;
        }
        .had-validate-status{
            color: #5ea026;
        }
        .submit-btn{
            min-width: 100px;
            margin-top: 30px;
            margin-left: 50%;
            transform: translateX(-50%);
        }
    }
    .see-sure-box{
        padding: 0 160px;
        .item-box{
            margin-bottom: 10px;
            .title{
                font-size: 18px;
                font-weight: 700;
            }
            .item-son{
                display: flex;
                margin-left: 30px;
                margin-top: 10px;
                font-size: 16px;
                .item-son-title{
                    width: 100px;
                    text-align: right;
                }
                .item-son-content{
                    margin-left: 4px;
                    font-weight: 600;
                }
            }
        }
        .btns-box{
            display: flex;
            margin-left: 50%;
            transform: translateX(-50%);
            margin-top: 30px;
            .btn{
                min-width: 100px;
                // margin-right: 10px;
            }
        }
    }
</style>